import script from "./statusCol.vue?vue&type=script&setup=true&lang=js"
export * from "./statusCol.vue?vue&type=script&setup=true&lang=js"

import "./statusCol.vue?vue&type=style&index=0&id=fdd8e2fc&lang=scss"

const __exports__ = script;

export default __exports__